// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import ActionBar from '../../layout/ActionBar';
import KeyPoolNotificationForm from './components/KeyPoolNotificationForm';
import {
  saveKeyPoolNotification,
  getKeyPoolNotificationById,
} from '../../../actions/keyPoolNotificationActions';
import { getAllWorkflows } from '../../../actions/workflowActions';
import { getKeyProviders } from '../../../actions/keyProviderActions';
import { getPlatforms } from '../../../actions/platformActions';
import Loading from '../../common/Loading';
import DeleteKeyPoolNotification from './slideout/DeleteKeyPoolNotification';
import SlidingPane from 'react-sliding-pane';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../../util/pageTitle';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { fetchAllGames } from '../../../reducers/gameReducer';

function KeyPoolNotification({
  workflows,
  getAllWorkflows,
  keyProviders,
  getKeyProviders,
  platforms,
  getPlatforms,
}) {
  const { id } = useParams();
  usePageTitle(['Key pool notification', 'Settings']);

  const games = useAppSelector((state) => state.games);
  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    setValue,
    watch,
  } = useForm();

  const onSubmit = (data) => {
    saveKeyPoolNotification({ ...keyPoolNotification, ...data })
      .then(() => {
        setKeyPoolNotification({ ...keyPoolNotification, ...data });
        toast.success(t('Key pool notification saved'));
      })
      .catch((e) => {
        toast.error(e.message || t('Failed to save key pool notification'));
      });
  };

  const [deleteSlideoutOpen, setDeleteSlideoutOpen] = useState(false);
  const handleDelete = (e) => {
    e.cancelBubble = true;
    setDeleteSlideoutOpen(true);
    return false;
  };

  const [keyPoolNotification, setKeyPoolNotification] = useState();

  useEffect(() => {
    if (id) {
      getKeyPoolNotificationById(id)
        .then((d) => {
          setKeyPoolNotification(d);
        })
        .catch((e) => {
          console.error(e);
          navigate('/settings/key-pool-notifications/');
          toast.error(t('Key pool notification not found'));
        });
    }
  }, [id, t, navigate]);

  useEffect(() => {
    if (!workflows) {
      getAllWorkflows();
    }
  }, [workflows, getAllWorkflows]);

  useEffect(() => {
    if (!keyProviders) {
      getKeyProviders();
    }
  }, [keyProviders, getKeyProviders]);

  useEffect(() => {
    if (!platforms) {
      getPlatforms();
    }
  }, [platforms, getPlatforms]);

  useEffect(() => {
    if (!games) {
      dispatch(fetchAllGames());
    }
  }, [games, dispatch]);

  return keyPoolNotification ? (
    <>
      <ActionBar
        breadcrumb={[
          {
            link: '/settings/key-pool-notifications',
            label: t('Key pool notifications'),
          },
          { label: t('Key pool notification') },
        ]}
      >
        <input
          type="button"
          value={t('Delete')}
          className="btn btn-danger me-2"
          onClick={handleDelete}
        />
        <input
          type="submit"
          value={t('Save')}
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
        />
      </ActionBar>
      {keyPoolNotification &&
      games &&
      workflows &&
      keyProviders &&
      platforms ? (
        <KeyPoolNotificationForm
          keyPoolNotification={keyPoolNotification}
          register={register}
          setValue={setValue}
          watch={watch}
          errors={errors}
          control={control}
          games={games}
          workflows={workflows}
          keyProviders={keyProviders}
          platforms={platforms}
        ></KeyPoolNotificationForm>
      ) : (
        ''
      )}

      <SlidingPane
        isOpen={deleteSlideoutOpen}
        hideHeader={true}
        from="right"
        className="small-side-panel"
        onRequestClose={() => setDeleteSlideoutOpen(false)}
      >
        <DeleteKeyPoolNotification
          id={id}
          done={(d) => {
            setDeleteSlideoutOpen(false);
            navigate('/settings/key-pool-notifications/');
          }}
          cancel={() => setDeleteSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  ) : (
    <Loading></Loading>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    workflows: state.workflows,
    keyProviders: state.keyProviders,
    platforms: state.platforms,
  };
}

const mapDispatchToProps = {
  saveKeyPoolNotification,
  getAllWorkflows,
  getKeyProviders,
  getPlatforms,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(KeyPoolNotification);
